// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file responses/v1/parcel_create_response.proto (package responses.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { Timestamp } from '@bufbuild/protobuf/wkt';
import { file_google_protobuf_timestamp } from '@bufbuild/protobuf/wkt';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file responses/v1/parcel_create_response.proto.
 */
export const file_responses_v1_parcel_create_response: GenFile =
    /*@__PURE__*/
    fileDesc(
        'CilyZXNwb25zZXMvdjEvcGFyY2VsX2NyZWF0ZV9yZXNwb25zZS5wcm90bxIMcmVzcG9uc2VzLnYxIioKB1BheW1lbnQSDQoFdG90YWwYASABKAESEAoIY3VycmVuY3kYAiABKAkiXwoMQ3VzdG9tZXJJbmZvEgoKAmlkGAEgASgDEg0KBWVtYWlsGAIgASgJEhIKCmZpcnN0X25hbWUYAyABKAkSEQoJbGFzdF9uYW1lGAQgASgJEg0KBXBob25lGAUgASgJIrICChRQcm92aWRlckluZm9SZXNwb25zZRIMCgR0eXBlGAEgASgJEhUKDXRyYW5zbGF0ZV9rZXkYAiABKAkSGgoSZnVsZmlsbG1lbnRfc3RhdHVzGAMgASgJEhYKDnBheW1lbnRfc3RhdHVzGAQgASgJEhwKD21hbmlmZXN0X3N0YXR1cxgFIAEoCUgAiAEBEhoKEmhhc19zaGlwcGluZ19sYWJlbBgGIAEoCBIZChFoYXNfc2hpcHBpbmdfbm90ZRgHIAEoCBIVCg1zaGlwcGluZ190eXBlGAggASgJEhEKCXNob3BfbmFtZRgJIAEoCRIUCgxzaG9wX2FkZHJlc3MYCiABKAkSGAoQcGFja2FnZV9wb2ludF9pZBgLIAEoCUISChBfbWFuaWZlc3Rfc3RhdHVzIs4CCg1PcmRlclJlc3BvbnNlEgoKAmlkGAEgASgJEhQKDG9yZGVyX251bWJlchgCIAEoBRISCgpvcmRlcl9uYW1lGAMgASgJEhIKCmNyZWF0ZWRfYXQYBCABKAkSJgoHcGF5bWVudBgFIAEoCzIVLnJlc3BvbnNlcy52MS5QYXltZW50EjEKDWN1c3RvbWVyX2luZm8YBiABKAsyGi5yZXNwb25zZXMudjEuQ3VzdG9tZXJJbmZvEjkKDXByb3ZpZGVyX2luZm8YByABKAsyIi5yZXNwb25zZXMudjEuUHJvdmlkZXJJbmZvUmVzcG9uc2USFwoPdHJhY2tpbmdfbnVtYmVyGAggASgJEjQKC3VubG9ja2VkX2F0GAkgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEgAiAEBQg4KDF91bmxvY2tlZF9hdCLxAQoUUGFyY2VsQ3JlYXRlUmVzcG9uc2USNgoRc3VjY2Vzc2Z1bF9vcmRlcnMYASADKAsyGy5yZXNwb25zZXMudjEuT3JkZXJSZXNwb25zZRIyCg1mYWlsZWRfb3JkZXJzGAIgAygLMhsucmVzcG9uc2VzLnYxLk9yZGVyUmVzcG9uc2USPgoGZXJyb3JzGAMgAygLMi4ucmVzcG9uc2VzLnYxLlBhcmNlbENyZWF0ZVJlc3BvbnNlLkVycm9yc0VudHJ5Gi0KC0Vycm9yc0VudHJ5EgsKA2tleRgBIAEoBBINCgV2YWx1ZRgCIAEoCToCOAFChAEKEGNvbS5yZXNwb25zZXMudjFCGVBhcmNlbENyZWF0ZVJlc3BvbnNlUHJvdG9QAVoELi9wYqICA1JYWKoCDFJlc3BvbnNlcy5WMcoCDFJlc3BvbnNlc1xWMeICGFJlc3BvbnNlc1xWMVxHUEJNZXRhZGF0YeoCDVJlc3BvbnNlczo6VjFiBnByb3RvMw',
        [file_google_protobuf_timestamp]
    );

/**
 * @generated from message responses.v1.Payment
 */
export type Payment = Message<'responses.v1.Payment'> & {
    /**
     * @generated from field: double total = 1;
     */
    total: number;

    /**
     * @generated from field: string currency = 2;
     */
    currency: string;
};

/**
 * Describes the message responses.v1.Payment.
 * Use `create(PaymentSchema)` to create a new message.
 */
export const PaymentSchema: GenMessage<Payment> =
    /*@__PURE__*/
    messageDesc(file_responses_v1_parcel_create_response, 0);

/**
 * @generated from message responses.v1.CustomerInfo
 */
export type CustomerInfo = Message<'responses.v1.CustomerInfo'> & {
    /**
     * @generated from field: int64 id = 1;
     */
    id: bigint;

    /**
     * @generated from field: string email = 2;
     */
    email: string;

    /**
     * @generated from field: string first_name = 3;
     */
    firstName: string;

    /**
     * @generated from field: string last_name = 4;
     */
    lastName: string;

    /**
     * @generated from field: string phone = 5;
     */
    phone: string;
};

/**
 * Describes the message responses.v1.CustomerInfo.
 * Use `create(CustomerInfoSchema)` to create a new message.
 */
export const CustomerInfoSchema: GenMessage<CustomerInfo> =
    /*@__PURE__*/
    messageDesc(file_responses_v1_parcel_create_response, 1);

/**
 * @generated from message responses.v1.ProviderInfoResponse
 */
export type ProviderInfoResponse = Message<'responses.v1.ProviderInfoResponse'> & {
    /**
     * @generated from field: string type = 1;
     */
    type: string;

    /**
     * @generated from field: string translate_key = 2;
     */
    translateKey: string;

    /**
     * @generated from field: string fulfillment_status = 3;
     */
    fulfillmentStatus: string;

    /**
     * @generated from field: string payment_status = 4;
     */
    paymentStatus: string;

    /**
     * @generated from field: optional string manifest_status = 5;
     */
    manifestStatus?: string | undefined;

    /**
     * @generated from field: bool has_shipping_label = 6;
     */
    hasShippingLabel: boolean;

    /**
     * @generated from field: bool has_shipping_note = 7;
     */
    hasShippingNote: boolean;

    /**
     * @generated from field: string shipping_type = 8;
     */
    shippingType: string;

    /**
     * @generated from field: string shop_name = 9;
     */
    shopName: string;

    /**
     * @generated from field: string shop_address = 10;
     */
    shopAddress: string;

    /**
     * @generated from field: string package_point_id = 11;
     */
    packagePointId: string;
};

/**
 * Describes the message responses.v1.ProviderInfoResponse.
 * Use `create(ProviderInfoResponseSchema)` to create a new message.
 */
export const ProviderInfoResponseSchema: GenMessage<ProviderInfoResponse> =
    /*@__PURE__*/
    messageDesc(file_responses_v1_parcel_create_response, 2);

/**
 * @generated from message responses.v1.OrderResponse
 */
export type OrderResponse = Message<'responses.v1.OrderResponse'> & {
    /**
     * @generated from field: string id = 1;
     */
    id: string;

    /**
     * @generated from field: int32 order_number = 2;
     */
    orderNumber: number;

    /**
     * @generated from field: string order_name = 3;
     */
    orderName: string;

    /**
     * @generated from field: string created_at = 4;
     */
    createdAt: string;

    /**
     * @generated from field: responses.v1.Payment payment = 5;
     */
    payment?: Payment | undefined;

    /**
     * @generated from field: responses.v1.CustomerInfo customer_info = 6;
     */
    customerInfo?: CustomerInfo | undefined;

    /**
     * @generated from field: responses.v1.ProviderInfoResponse provider_info = 7;
     */
    providerInfo?: ProviderInfoResponse | undefined;

    /**
     * @generated from field: string tracking_number = 8;
     */
    trackingNumber: string;

    /**
     * @generated from field: optional google.protobuf.Timestamp unlocked_at = 9;
     */
    unlockedAt?: Timestamp | undefined;
};

/**
 * Describes the message responses.v1.OrderResponse.
 * Use `create(OrderResponseSchema)` to create a new message.
 */
export const OrderResponseSchema: GenMessage<OrderResponse> =
    /*@__PURE__*/
    messageDesc(file_responses_v1_parcel_create_response, 3);

/**
 * @generated from message responses.v1.ParcelCreateResponse
 */
export type ParcelCreateResponse = Message<'responses.v1.ParcelCreateResponse'> & {
    /**
     * @generated from field: repeated responses.v1.OrderResponse successful_orders = 1;
     */
    successfulOrders: OrderResponse[];

    /**
     * @generated from field: repeated responses.v1.OrderResponse failed_orders = 2;
     */
    failedOrders: OrderResponse[];

    /**
     * @generated from field: map<uint64, string> errors = 3;
     */
    errors: { [key: string]: string };
};

/**
 * Describes the message responses.v1.ParcelCreateResponse.
 * Use `create(ParcelCreateResponseSchema)` to create a new message.
 */
export const ParcelCreateResponseSchema: GenMessage<ParcelCreateResponse> =
    /*@__PURE__*/
    messageDesc(file_responses_v1_parcel_create_response, 4);
